import type React from 'react';

import { Label, LabeledControl, Radio, Text } from '@zillow/constellation-10';
import type { Section } from '../../models';

type Props = {
  option1FieldName: string;
  option1Header: string;
  option1Content: string;
  option2FieldName: string;
  option2Header: string;
  option2Content: string;
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  initialState?: object;
};

export default function RadioListBox({
  option1FieldName,
  option1Header,
  option1Content,
  option2FieldName,
  option2Header,
  option2Content,
  section,
  setSectionValues,
  initialState,
}: Props): JSX.Element {
  function onOptionChange(event: React.ChangeEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;
    setSectionValues({
      [option1FieldName]: value === option1FieldName,
      [option2FieldName]: value === option2FieldName,
      ...initialState,
    });
  }

  const currentValue = section.getFieldValue(option1FieldName)
    ? option1FieldName
    : section.getFieldValue(option2FieldName)
      ? option2FieldName
      : '';

  return (
    <>
      <LabeledControl
        size="lg"
        label={
          <Label>
            {option1Header}
            <br />
            <Text css={{ color: 'text.subtle' }}>{option1Content}</Text>
          </Label>
        }
        control={
          <Radio
            name="radio-listbox"
            value={option1FieldName}
            checked={currentValue === option1FieldName}
            onChange={onOptionChange}
            disabled={section.isFieldDisabled(option1FieldName)}
          />
        }
      />
      <LabeledControl
        size="lg"
        label={
          <Label>
            {option2Header}
            <br />
            <Text css={{ color: 'text.subtle' }}>{option2Content}</Text>
          </Label>
        }
        control={
          <Radio
            name="radio-listbox"
            value={option2FieldName}
            checked={currentValue === option2FieldName}
            onChange={onOptionChange}
            disabled={section.isFieldDisabled(option2FieldName)}
          />
        }
      />
    </>
  );
}
